<template>
<div class="Quotation">
  <!-- 模板1、2 -->
  <div v-if="template==1||template==2" :class="'temp-'+template" class="pt5">
    <div class="font-bold pb5" style="font-size: 36px;">{{item.name}}</div>
    <!-- <div class="fs4 pb2">销售清单</div> -->
    <div v-if="template==1" class="row align-self-center justify-content-between font-bold pl2 pr2 fs5">
      <div v-if="item.customer"><span style="letter-spacing: 5px;">客户</span><span class="pl1">{{item.customer||''}}</span></div>
      <div v-else-if="item.priceType"><span class="pl1">{{item.priceType||''}}</span></div>
      <div>
        <template >{{queryDateString||showDateString}}</template>
        <!-- <template>年<span class="pl7">月</span><span class="pl7">日</span></template> -->
      </div>
    </div>
    <table class="fs6">
      <thead v-if="pageType==='bill' || (item.quotes && item.quotes.length > 0)">
        <tr>
          <th>
            <div>行话</div>
            <div class="fs3">(分类)</div>
          </th>
          <th>
            <div v-if="QUOTE_SECTION[item.section]" class="quote-section-yellow">{{QUOTE_SECTION[item.section]}}</div>
            <div v-else>规格</div>
            <div class="fs3">{{item.unitText?'(':''}}{{item.unitText}}{{item.unitText?')':''}}</div>
          </th>
          <th width="25%">
            <!-- <span class="fs1">(元/斤)</span> -->
            <div>{{'价格'}}</div>
            <div class="fs3">(元/斤)</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(quo, qindex) in processedQuotes" :key="qindex">
          <td>{{quo.categoryText||''}}</td>
          <td v-if="quo.showSpec" :rowspan="quo.specRowspan" :class="{'spec-cell-merged-table': quo.specRowspan > 1}">{{quo.weightText||''}}</td>
          <td><div>{{quo.tPrice||quo.price||''}}</div></td>
        </tr>
      </tbody>
    </table>
    <div class="row align-items-center pl3 pt7 pb2">
      <div class="flex-1 text-left fs2 font-bold pr9 pb1">
        <!-- <div class="row-border pr1 pt1 row align-items-end">
          <div class="row-label">主营</div>
          <div class="flex-1 pl5">{{item.mainProducts}}</div>
        </div> -->
        <div class="row-border pr1 pt2 row align-items-end">
          <div class="row-label">备注</div>
          <div class="flex-1 pl5">{{item.describe}}</div>
        </div>
        <div class="row-border pr1 pt2 row align-items-end">
          <div class="row-label">电话</div>
          <div class="flex-1 pl5">
            <div v-for="(mo) in item.mobileList"
              :key="mo.mobile"
            >
              <span class="pr1">{{mo.name}}</span>
              <a class="pl1 pr1"
              :href="'tel:'+(mo.mobile || '')">{{mo.mobile || ''}}</a>
            </div>
          </div>
        </div>
        <div class="row-border pr1 pt2 row align-items-end">
          <div class="row-label">地址</div>
          <div class="flex-1 pl5">{{item.address}}</div>
        </div>
      </div>
      <div class="row justify-content-center align-items-center">
        <template v-if="!$route.meta||!$route.meta.hideQrcode">
          <div @click="previewImage(qrcodeUrl, 0)"  v-if="qrcodeUrl" class="text-center pb3">
            <img :src="qrcodeUrl" :width="qrcodeSize" :height="qrcodeSize" style="border-radius: 4px">
            <div class="text-center fs2 pl1 pr1">扫码加微信</div>
          </div>
          <div @click="previewImage(miniQrCode, 1)"  v-if="miniQrCode" class="text-center pb3">
            <img :src="miniQrCode" :width="qrcodeSize" :height="qrcodeSize" style="border-radius: 4px">
            <div class="text-center fs2 pl1 pr1">扫码看门店</div>
          </div>
        </template>
      </div>
      <!-- <div v-else class="wechat-header">
        <div class="header">微信二维码</div>
      </div> -->
    </div>
  </div>
  <!-- 模板3 -->
  <template v-else>
    <div v-if="item.createDate" class="text-left fs4 fc-red-cus">{{handleUpdateTime(item.createDate).updateTimeStr}}更新</div>
    <div class="bc-white over-hidden item-box">
      <!-- <div v-if="item.priceType" class="price-tag">
        <img class="price-tag-bg" src="../assets/price_arc.png">
        <div class="price-tag-text" :style="{'font-size': item.priceType&&item.priceType.length>3?'12px':''}">{{item.priceType}}</div>
      </div> -->
      <!-- <div class="guarantee-tag">
        <div>担保金</div>
        <div>{{item.guarantee}}</div>
      </div> -->
      <div class="bc-title fc-white pt2 pb2 pos-rel quotation-title">
        <div
          v-if="item.priceType"
          class="price-tag-text row align-items-center justify-content-center"
          :style="{'font-size': item.priceType&&item.priceType.length>4?'13px':''}"
        >
          {{item.priceType}}
        </div>
        <div class="ff-bold fs7 merchant-name">{{item.address}}</div>
        <div class="fs6">{{item.name}}</div>
      </div>
      <div v-if="item.quotes && item.quotes.length > 0"
        class="quote-table-grid item font-bold fs6 bc-tr fc-white"
        :class="{'grid-3-cols': pageType!=='quotaion'}">
        <div class="grid-cell grid-col-1">
          <div>行话</div>
          <div class="fs3">(分类)</div>
        </div>
        <div class="grid-cell grid-col-2" :class="QUOTE_SECTION[item.section] ? 'quote-section' : ''">
          <div v-if="QUOTE_SECTION[item.section]" class="fc-red">{{QUOTE_SECTION[item.section]}}</div>
          <div v-else>规格</div>
          <div class="fs3 quote-unit">{{item.unitText?'(':''}}{{item.unitText}}{{item.unitText?')':''}}</div>
        </div>
        <div class="grid-cell grid-col-3" :class="{'grid-cell-last': pageType!=='quotaion'}">
          <div>{{showDateString||'价格'}}</div>
          <div class="fs3">(元/斤)</div>
        </div>
        <!-- <div class="col">昨天</div> -->
        <div v-if="pageType==='quotaion'" class="grid-cell grid-col-4">
          <div>同比昨天</div>
          <div class="fs3">(元/斤)</div>
        </div>
      </div>
      <div class="quote-table-grid" :class="{'grid-3-cols': pageType!=='quotaion'}">
        <div v-for="(quo, qindex) in processedQuotes" :key="`row-${qindex}`" class="grid-row-contents">
          <!-- 行话列 -->
          <div class="grid-cell line-top grid-col-1" :class="quo.categoryText && quo.categoryText.length>5?'fs4':'fs7'">
            {{quo.categoryText}}
          </div>
          <!-- 规格列：支持合并 -->
          <div
            v-if="quo.showSpec"
            class="grid-cell line-top grid-col-2 spec-cell"
            :class="{'spec-cell-merged': quo.specRowspan > 1}"
            :style="quo.specRowspan > 1 ? 'grid-row: span ' + quo.specRowspan : ''"
          >
            {{quo.weightText||''}}
          </div>
          <!-- 价格列 -->
          <div class="grid-cell line-top grid-col-3 fs7" :class="{'grid-cell-last': pageType!=='quotaion'}">
            {{quo.tPrice||quo.price||''}}
          </div>
          <!-- 同比昨天列 -->
          <div v-if="pageType==='quotaion'" class="grid-cell line-top grid-col-4 fs7">
            <span v-if="quo.priceChange.type === 'no-data'" class="fc-suppl">
              {{quo.priceChange.text}}
            </span>
            <div v-else-if="quo.priceChange.type === 'up'" class="row align-items-center justify-content-center">
              <span class="price-status bc-red">{{quo.priceChange.text}}</span>
              <span class="pl1 fc-danger">{{quo.priceChange.value}}</span>
            </div>
            <span v-else-if="quo.priceChange.type === 'flat'" class="pl1">
              {{quo.priceChange.text}}
            </span>
            <div v-else-if="quo.priceChange.type === 'down'" class="row align-items-center justify-content-center">
              <span class="price-status bc-blue">{{quo.priceChange.text}}</span>
              <span class="pl1 fc-blue">{{quo.priceChange.value}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bc-primary-info text-left padding2 row align-items-center fs5 fc-dark line-top">
        <div class="flex-1">
          <!-- <div><span class="pl2">发布时间：</span>{{item.createDate}}</div> -->
          <!-- <div v-if="item.createDate"><span class="pl2">{{pageType==='quotaion' ? '最近一次' : ''}}报价时间：</span>{{handleUpdateTime(item.createDate).publishTimeStr}}</div> -->
          <div v-if="item.info1"><span class="pl2">运费：</span>{{item.info1}}</div>
          <div v-if="item.info2"><span class="pl2">死亡：</span>{{item.info2}}</div>
          <div v-if="item.describe"><span class="pl2">备注：</span>{{item.describe}}</div>
          <div v-if="item.adSlogan"><span class="pl2">宣传语：</span>{{item.adSlogan}}</div>
          <!-- <div><span class="pl2">发布时间：</span>{{item.createDate}}</div> -->
          <!-- <div><span class="pl2">最近一次报价时间：</span>{{handleUpdateTime(item.createDate).publishTimeStr}}</div> -->

        </div>
      </div>
      <div class="bc-red font-bold fc-white row justify-content-center align-items-center">
        <div class="col-24 row justify-content-center align-items-center pt2 pb2">
          <van-icon name="phone" size="16" />
          <div v-for="(mo, moindex) in item.mobileList"
            :key="mo.mobile"
          >
            <template v-if="moindex!==0">/</template>
            <span class="pl1">{{mo.name}}</span>
            <a class="pl1 pr1 fc-white fs6"
            :href="'tel:'+(mo.mobile || '')">{{mo.mobile || ''}}</a>
          </div>
        </div>
        <div @click="previewImage(qrcodeUrl, 0)"  v-if="qrcodeUrl&&(!$route.meta||!$route.meta.hideQrcode)" class="col-12 text-center pb3">
          <img :src="qrcodeUrl" width="100" height="100" style="border-radius: 4px">
          <div class="text-center fs8">扫码加微信</div>
        </div>
        <div @click="previewImage(miniQrCode, 1)"  v-if="miniQrCode&&(!$route.meta||!$route.meta.hideQrcode)" class="col-12 text-center pb3">
          <img :src="miniQrCode" width="100" height="100" style="border-radius: 4px">
          <div class="text-center fs8">扫码看门店</div>
        </div>
      </div>
    </div>
  </template>
    <!-- 图片预览弹框 -->
    <van-popup
      v-model="previewShow"
      position="bottom"
    >
      <div class="pb10 pl2 pr2">
        <van-image
          width="100%"
          height="60vh"
          fit="contain"
          :src="priviewQrcodeUrl"
        >
          <template v-slot:loading>
            图片加载中<van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <van-icon class="mt7"
          @click="previewImage('')"
          :size="36" color="#fff" name="close" />
        <div class="text-center mt10 pb10 fc-white fs10">
          长按图片识别二维码{{previewType === 1 ?'看门店':'加微信'}}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { QUOTE_SECTION } from '@/uitls/const';
import config from '../config';

export default Vue.extend({
  name: 'Quotation',
  components: {},
  data() {
    return {
      QUOTE_SECTION,
      previewShow: false,
      previewType: 0,
      fileDomain: config.FILE_DOMAIN,
      priviewQrcodeUrl: '',
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    queryDateString: {
      type: String,
      default: '',
    },
    template: {
      type: String,
      default: '3',
    },
    pageType: { // 页面类型 quotaion--正常报价页面；bill--报价单小工具;
      type: String,
      default: 'quotaion',
    },
  },
  computed: {
    qrcodeSize() {
      if (this.template === '3') {
        return 100;
      }
      if (this.qrcodeUrl && this.miniQrCode) {
        return 80;
      }
      return 100;
    },
    qrcodeUrl() {
      const { qrcodeUrl } = this.item;
      if (!qrcodeUrl) {
        return '';
      }
      if (qrcodeUrl.startsWith('http')) {
        return qrcodeUrl;
      }
      if (qrcodeUrl.includes('images/')) {
        return `${this.fileDomain}${qrcodeUrl}`;
      }
      return qrcodeUrl;
    },
    miniQrCode() {
      const { miniQrCode } = this.item;
      if (!miniQrCode) {
        return '';
      }
      if (miniQrCode.startsWith('http')) {
        return miniQrCode;
      }
      if (miniQrCode.includes('images/')) {
        return `${this.fileDomain}${miniQrCode}`;
      }
      return miniQrCode;
    },
    processedQuotes() {
      if (!this.item.quotes || !Array.isArray(this.item.quotes)) {
        return [];
      }

      const processed = this.item.quotes.map((quo) => {
        const result = { ...quo };

        // 计算涨跌信息
        const tPrice = quo.tPrice || 0;
        const yPrice = quo.yPrice || 0;

        if (!yPrice) {
          // 昨天没报价
          result.priceChange = {
            type: 'no-data',
            text: '昨天没报',
            value: 0,
          };
        } else if (tPrice > yPrice) {
          // 涨
          const diff = Number((tPrice - yPrice).toFixed(1));
          const formattedDiff = diff % 1 === 0 ? Math.abs(diff).toFixed(0) : Math.abs(diff).toFixed(1);
          result.priceChange = {
            type: 'up',
            text: '涨',
            value: formattedDiff,
          };
        } else if (tPrice === yPrice) {
          // 平
          result.priceChange = {
            type: 'flat',
            text: '平',
            value: 0,
          };
        } else {
          // 跌
          const diff = Number((yPrice - tPrice).toFixed(1));
          const formattedDiff = diff % 1 === 0 ? Math.abs(diff).toFixed(0) : Math.abs(diff).toFixed(1);
          result.priceChange = {
            type: 'down',
            text: '跌',
            value: formattedDiff,
          };
        }

        return result;
      });

      // 处理规格列合并
      let currentSpec = null;
      let specStartIndex = -1;

      processed.forEach((quo, index) => {
        const spec = quo.weightText || '';

        if (spec !== currentSpec) {
          // 新规格开始，回填之前规格的 rowspan
          if (specStartIndex >= 0) {
            processed[specStartIndex].specRowspan = index - specStartIndex;
          }

          currentSpec = spec;
          specStartIndex = index;
          processed[index].specRowspan = 1;
          processed[index].showSpec = true;
        } else {
          // 相同规格，隐藏规格列
          processed[index].showSpec = false;
        }
      });

      // 处理最后一个规格的 rowspan
      if (specStartIndex >= 0) {
        processed[specStartIndex].specRowspan = processed.length - specStartIndex;
      }

      return processed;
    },
    showDateString() {
      if (this.queryDateString) {
        return this.queryDateString;
      }
      const now = this.item.createDate ? new Date(this.item.createDate) : new Date();
      // 当前时间是晚上19点以后，那么就显示明天的日期（晚上7点后报价报的是第二天的价格），否则正常显示
      if (now.getHours() >= 19) {
        now.setDate(now.getDate() + 1);
      }
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      if (`${this.template}` === '3') {
        return `${month}月${day}`;
      }
      return `${year} 年 ${month} 月 ${day} 日`;
    },
  },
  methods: {
    handleUpdateTime(dateStr) {
      if (!dateStr) {
        return '';
      }
      // eslint-disable-next-line no-underscore-dangle
      const _dateStr = dateStr.replaceAll('-', '/');
      const [year, month, day, hour, min] = new Date(_dateStr).toLocaleString('zh-cn', { hour12: false }).split(/[/ :]/);
      const [currentYear, currentMonth, currentDay] = new Date().toLocaleDateString().split('/');
      let str = `${month}月${day}`;
      // 如果是当天
      if (year === currentYear && month === currentMonth && day === currentDay) {
        str = '今天';
      }
      const updateTimeStr = `${str} ${hour}:${min}`;
      const publishTimeStr = `${year}年${month}月${day}日`;
      return {
        updateTimeStr,
        publishTimeStr,
      };
    },
    previewImage(url, type) {
      this.previewShow = !this.previewShow;
      this.priviewQrcodeUrl = url.includes('http') ? url : `${this.fileDomain}${url}`;
      this.previewType = type;
    },
    imgLoaded() {
      this.$emit('load', true);
    },
    imgError() {
      this.$emit('load', false);
    },
  },
  created() {
  },
});
</script>
<style scoped>
.Quotation {
  position: relative;
  /* width: 100vw; */
  /* background-color: #ffffff; */
}
  /* 模板1 */
  .temp-1 {
    color: #E9071B;
    padding: 10px 8px 5px 8px;
    background-color: #ffffff;
  }
  .temp-1 table {
    border-top: 1px solid #CCCBC7;
    border-left: 1px solid #CCCBC7;
    border-bottom: 1px solid #CCCBC7;
    width: 100%;
    border-spacing: 0;
  }
  .temp-1 .row-border {
    border-bottom: 1px solid #CCCBC7;
  }
  .temp-1 table th{
    padding: 3px 1px;
    border-right: 1px solid #CCCBC7;
  }
  .temp-1 table td{
    padding: 3px 1px;
    border-top: 1px solid #CCCBC7;
    border-right: 1px solid #CCCBC7;
  }
  .temp-1 table td div{
    min-height: 23px;
  }
  .wechat-header{
    background-color: #ffffff;
    padding: 3px;
    width: 76px;
    height: 76px;
  }
  .header{
    border: 1px solid #0e3a5f;
    color: #232323;
    height: 100%;
    font-size: 12px;
    line-height: 70px;
    font-weight: bold;
  }
  .temp-1 .row-label{
    width: 60px;
  }
  .temp-1 a {
    color: #E9071B;
  }
  .temp-2 a {
    color: #000000;
  }
  /* 模板1 */
  .temp-2 {
    color: #000000;
    padding: 10px 8px 5px 8px;
    background-color: #F9F9FB;
  }
  .temp-2 table {
    width: 100%;
    border-spacing: 0;
  }
  .temp-2 .row-border {
    border-bottom: 1px solid #A09E9F;
  }
  .temp-2 table th{
    padding: 3px 1px;
    border-top: 1px solid #A09E9F;
  }
  .temp-2 table td{
    padding: 3px 1px;
  }
  .temp-2 table td div{
    min-height: 23px;
  }
  .temp-2 .row-label{
    width: 60px;
  }
  /* 模板3 */
  .fc-quotation {
    color: #0e3a5f;
  }
  .item-box {
    position: relative;
    color: #0e3a5f;
    box-shadow: 0px 4px 6px #7d7979;
    border-radius: 16px;
    border: 2px solid #1e67c7;
  }
  .guarantee-tag {
    position: absolute;
    right: 15px;
    top: 0;
    /* background-color: #621f70; */
    color: white;
    font-size: 12px;
    padding: 4px 5px 12px;
    background-image: url('../assets/guarantee_tag.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .quotation-title {
    padding-left: 65px;
    padding-right: 5px;
  }
  .price-tag {
    position: absolute;
    left: 0;
    top: 0;
    /* background-color: #b8d0f2; */
    /* color: #1e67c7; */
    width: 76px;
    height: 35px;
    z-index: 1;
  }
  .price-tag-bg {
    width: 100%;
  }
  .price-tag-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 70px;
    /* padding-top: 5px; */
    /* padding-right: 10px; */
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    background: rgba(255, 255, 0, 1);
    /* border: 1px solid #0e3a5f; */
    border-top-left-radius: 16px;
    color: red;
    height: 100%;
    /* padding: 10px; */
    vertical-align: middle;
  }
  .line-top {
    border-top: 2px solid #1e67c7;
  }
  .line-bottom {
    border-bottom: 1px solid #e6e1e1;
  }
  .line-left {
    border-left: 1px solid #e6e1e1;
  }
  .item .col {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 1px;
    min-height: 26px;
  }
  .refresh {
    position: fixed;
    bottom: 20vh;
    right: 5px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
    color: #ffffff;
  }
  .backtop {
    bottom: calc(20vh - 50px);
  }
  /* .quotation-icon {
    width: 30px;
    height: 30px;
  } */
  .notice-fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
  .notice-fixed-height {
    padding: 0 5px 2px 5px;
    width: 100%;
    font-size: .8rem;
    /* margin: 0 auto; */
  }
  .notice-place-holder {
    opacity: 0;
  }
  .bottombtn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #ece8e8;
    /* padding: 4px; */
    box-shadow: 1px -2px 6px #7d7979;
  }
  .bottombtn-height {
    height: 46px;
  }
  .bottom-btn {
    line-height: 1;
    font-size: 14px;
  }
  .bottom-btn button {
    margin: 0;
  }
  .fc-suppl {
    color: #1e67c7;
  }
  .bc-title {
    background-color: #1e67c7;
  }
  .bc-tr {
    background-color: #0e3a5f;
  }
  .merchant-name {
    /* padding-left: 65px; */
    padding-right: 10px;
  }
  .fc-danger {
    color: #b71831!important;
  }
  .fc-red {
    color: red!important;
  }
  .bc-red {
    background-color: #b71831!important;
  }
  .bc-blue {
    background-color: #00bcd4!important;
  }
  .fc-blue {
    color: #00bcd4!important;
  }
  .quote-section-yellow {
    background: rgba(255, 255, 0, 1);
    color: red;
    margin:0 6px;
    border-radius: 6px;
  }
  .quote-section {
    background: rgba(255, 255, 0, 1);
    border-radius: 6px;
  }
  .quote-section .quote-unit {
    color: #000000;
  }
  .price-status {
    color: #ffffff;
    border-radius: 4px;
    font-size: 13px;
    text-align: center;
    line-height: 18px;
    width: 19px;
    height: 19px;
  }
  .van-popup {
    background-color: transparent;
  }
  /* 规格列合并样式 - Grid 布局 */
  .quote-table-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    color: #0e3a5f;
  }
  .quote-table-grid.grid-3-cols {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .grid-row-contents {
    display: contents;
  }
  .grid-cell {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 1px;
    min-height: 26px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 2px solid #1e67c7;
  }
  .grid-cell:last-child {
    border-right: none;
  }
  .grid-col-1 {
    grid-column: 1;
  }
  .grid-col-2 {
    grid-column: 2;
  }
  .grid-col-3 {
    grid-column: 3;
  }
  .grid-col-4 {
    grid-column: 4;
    border-right: none;
  }
  .grid-cell-last {
    border-right: none;
  }
  .border-top {
    border-top: 2px solid #1e67c7;
  }
  /* Table 合并单元格样式 */
  .spec-cell-merged-table {
    vertical-align: middle;
  }
</style>
